import { styled } from "@mui/material"
import { Switch, SwitchProps } from "./switch"

type TriState = true | false | undefined

type TriStateSwitchProps = SwitchProps & {
    value: TriState
    onToggle?: (val: Exclude<TriState, undefined>) => void
    label?: string
}

const StyledTriSwitch = styled(Switch, {
    shouldForwardProp: (prop) => prop !== "tristate",
})<{ tristate: TriState }>(({ tristate }) => ({
    "& .MuiSwitch-switchBase": {
        transform:
            tristate === undefined
                ? "translateX(10px)" // center thumb
                : undefined,
    },
    "& .MuiSwitch-track": {
        "&::after": {
            display: tristate !== false ? "none" : "unset",
        },
    },
}))

/**
 * TriStateSwitch extends MUI's Switch to support a third 'undefined' state.
 * - Starts as undefined (thumb centered), switches to true on first click.
 * - Then toggles between true and false.
 * - Works as a regular switch when value is true/false only.
 */
export function TriStateSwitch({ value, onToggle, label, ...rest }: TriStateSwitchProps) {
    const handleToggle = () => {
        onToggle?.(!value)
    }

    return <StyledTriSwitch onChange={handleToggle} checked={!!value} tristate={value} disableRipple label={label} {...rest} />
}
